import React from 'react';
import clsx from 'clsx';
import { DataCard } from '@brighterion/br-ui';
import { useTranslation } from 'react-i18next';
import { shouldShowExecutionOrder } from 'Selectors';
import styles from './GlobalRuleDetails.css';

type Props = {
    ruleIsActive: boolean;
    dataTestId: string;
    // Since we're going through the table format function
    // active is actually a string -- should figure out how to fix this lol.
    globalRule: Rule;
    ruleTypeString?: string;
};

const GlobalRuleDetails = ({ dataTestId, globalRule, ruleIsActive, ruleTypeString }: Props) => {
    const { t } = useTranslation();
    const showExecutionOrder = shouldShowExecutionOrder();
    return (
        <>
            <div data-testid={`${dataTestId}-title`} className={styles.title}>
                {t(`${ruleTypeString || 'Global'} Rule`)}
            </div>
            <div
                data-testid='datacard-container'
                className={clsx(styles.datacardContainer, !ruleIsActive && styles.inactive)}
            >
                <div className={styles.row}>
                    <DataCard
                        className={styles.ruleId}
                        dataTestId={`${dataTestId}-ruleid`}
                        label={t('Rule ID')}
                        data={globalRule.id}
                    />
                    {showExecutionOrder && (
                        <DataCard
                            className={styles.ruleId}
                            dataTestId={`${dataTestId}-executionorder`}
                            label={t('executionOrder')}
                            data={globalRule.priority}
                        />
                    )}
                    <DataCard
                        dataTestId={`${dataTestId}-status`}
                        className={styles.status}
                        label={t('Status')}
                        data={globalRule?._formatted?.active}
                    />
                    {!showExecutionOrder && (
                        <DataCard
                            dataTestId={`${dataTestId}-rulegroup`}
                            label={t('Rule Group')}
                            data={globalRule.ruleGroup}
                        />
                    )}
                </div>
                {showExecutionOrder && (
                    <div className={styles.row}>
                        <DataCard
                            dataTestId={`${dataTestId}-rulegroup`}
                            label={t('Rule Group')}
                            data={globalRule.ruleGroup}
                        />
                    </div>
                )}
                <DataCard
                    dataTestId={`${dataTestId}-rule-description`}
                    className={styles.description}
                    label={t('Rule Description')}
                    // inputDescription contains description without conclusion value
                    data={globalRule?._formatted?.inputDescription}
                />
            </div>
        </>
    );
};

export default React.memo(GlobalRuleDetails);
